import { Pipe, PipeTransform } from '@angular/core';

const FIXED = new Intl.NumberFormat('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const AUTO = new Intl.NumberFormat('en-NG', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

/**
 * Formats a number as naira.
 *   {{ 1500000 | naira }}          → ₦1,500,000.00   (modals, receipts)
 *   {{ 1500000 | naira: 'auto' }}  → ₦1,500,000      (tables and cards: kobo only when there is some)
 */
@Pipe({ name: 'naira', standalone: true })
export class NairaPipe implements PipeTransform {
  transform(value: number | null | undefined, decimals: 'fixed' | 'auto' = 'fixed'): string {
    const formatter = decimals === 'auto' ? AUTO : FIXED;
    return `₦${formatter.format(value ?? 0)}`;
  }
}
